/* eslint-disable */

export const UPDATE_ORDER_STATUS = {
    UPDATE_ORDER_STATUS_REQUEST: 'UPDATE_ORDER_STATUS_REQUEST',
    UPDATE_ORDER_STATUS_SUCCESS: 'UPDATE_ORDER_STATUS_SUCCESS',
    UPDATE_ORDER_STATUS_FAILURE: 'UPDATE_ORDER_STATUS_FAILURE',
};
